export const currencies = ["CNY", "USD", "EUR", "GBP", "HKD", "SGD", "MYR", "THB", "PHP", "IDR", "VND"] as const;
export type Currency = (typeof currencies)[number];
export const currencyMinorDigits: Record<Currency, number> = {
  CNY: 2,
  USD: 2,
  EUR: 2,
  GBP: 2,
  HKD: 2,
  SGD: 2,
  MYR: 2,
  THB: 2,
  PHP: 2,
  IDR: 2,
  VND: 0
};

export type Money = {
  amountMinor: number;
  currency: Currency;
};

export const roles = ["admin", "finance_maker", "finance_reviewer", "operations"] as const;
export type Role = (typeof roles)[number];

export type SessionUser = {
  id: string;
  name: string;
  email: string;
  role: Role;
};
